import { types, getEnv, flow, Instance } from 'mobx-state-tree';
import { IAppEnv } from '../appEnvironment';
import { IGroupedApiCtx, ProgressStateModelForStore, ProgressStateModel } from 'eTip--common';
import { ILinksApi } from '../api/apiLinks';

export const sportLinks = types.model({
    name: types.maybeNull(types.string),
    icon: types.maybeNull(types.string),
    category: types.array(
        types.model({
            url: types.optional(types.array(types.string), []),
            name: types.string,
            subcategory: types.optional(
                types.array(
                    types.model({
                        url: types.optional(types.array(types.string), []),
                        name: types.string
                    })
                ),
                []
            )
        })
    )
});

export const LinksStoreKey = 'linksStore';
export const LinksStore = types
    .model(LinksStoreKey, {
        sports: types.optional(types.array(sportLinks), []),
        activeTab: types.string,
        state: types.optional(ProgressStateModelForStore, ProgressStateModel.NotInitialized)
    })
    .actions(self => {
        const env = getEnv<IAppEnv>(self);
        let ctx: IGroupedApiCtx<ILinksApi> | null = null;
        const load = flow(function* () {
            self.state = ProgressStateModel.Loading;
            try {
                if (ctx && ctx.isOpen()) ctx.cancel('Load has been canceled.');
                ctx = env.linksApi.open();
                const r = yield ctx.api.getLinks();
                setItems(r);
                self.state = ProgressStateModel.Success;
            } catch (error) {
                self.state = ProgressStateModel.Failed;
            } finally {
                ctx = null;
            }
        });

        const setItems = (items: any) => {
            self.sports = items;
        };
        const toggleTab = (tabKey: string) => {
            self.activeTab = tabKey;
        };
        return {
            load,
            toggleTab
        };
    });
export type ILinksStore = Instance<typeof LinksStore>;
